import React, {useState} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import cogoToast from 'cogo-toast';
import DatePicker from "react-datepicker";
import {  kaReducer, Table } from 'ka-table';
import { search, loadData, updateData } from 'ka-table/actionCreators';
import { SortingMode,PagingPosition } from 'ka-table/enums';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import shipingService from '../services/shiping-service';
import moment from "moment";
const tablePropsInit = {
  columns: [
    { key: 'fac_name', title: 'Facility Name'},
    { key: 'fac_code', title: 'DCode'},    
    { key: 'fac_id', title: 'Facility ID'},
    { key: 'Actions'},
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: 'fac_id',
  search: ({ searchText, rowData, column }) => {
    if (column.key === 'passed'){
      return (searchText === 'false' && !rowData.passed) || (searchText === 'true' && rowData.passed);
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom
  },
};
const PackingPublishListTab = ({history,cutOffList}) => {
  const [loading, setLoading] = useState(false);
    const [publishDate, setpublishDate] = useState(); 
    const [showPublishList, setShowPublishList] = useState('hidden');     
    const CustomCell = ({rowData}) => {
      return (
        <div>    
            <span className="inline-block mr-3">
              <a href={rowData.file_url} download="packingSlip.pdf">Download</a>  
            </span>          
        </div>
      );
    };
    const [tableProps, changeTableProps] = useState(tablePropsInit);
    let dispatch1 = async (action) => {
      changeTableProps((prevState) => kaReducer(prevState, action));
    };
    const getPublishList = async () => {
      if (!publishDate) {
        const { hide } = cogoToast.error("Please chose valid date", {hideAfter:15,
          onClick: () => {
            hide();
          },
        });
      } else {
        try {
          let returnList = await shipingService.publistList(moment(publishDate).format("YYYY-MM-DD"));
          setLoading(true);
          setLoading(false);
          if (returnList.length>0) {          
            setShowPublishList('');
            dispatch1(updateData(returnList));
          }else {
            const { hide } = cogoToast.error("No Records Found!", {hideAfter:15,
              onClick: () => {
                hide();
              },
            });
            setShowPublishList('hidden');
            dispatch1(updateData([]));
          } 
        } catch (e) {
          console.error(e);
        }
      }
    };
return (
    <div>  
      <div className={`inline-block customtop z-50 absolute ${loading ? "show" : "hidden"}`}>
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-full mx-auto">
        <div className="p-2">
          <div className="w-full">
              <div>
              <span className="w-1/4 inline-block">
                <p className="text-labelclr font-semibold text-sm tracking-wider">Select Date</p>
                <DatePicker placeholderText = "MM/DD/YYYY" selected={publishDate} onChange={(date) => {setpublishDate(date)}} className='w-full border h-10 rounded pl-2 text-labelclr font-semibold text-xs tracking-wider '/>
              </span>              
              
              <span className="w-1/5 inline-block text-center">
              <button
                    onClick={() => {
                      getPublishList();
                    }}
                    type="button"
                    className="text-white w-full h-10 px-6 bg-header_bg rounded text-xs font-semibold capitalize focus:outline-none focus:none"
                  >
                    SUBMIT
                  </button>
              </span>
              <div className={` w-1/3 inline-block float-right mt-4 ${showPublishList}`}>
              <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-full h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 -top-1 bottom-3"
              ></img>
            </span>
              </div>     
              </div>
          </div> 
              
        </div>
        <div className={`${showPublishList}`}>            
          <div className="p-2 text-xs publishList gridList overflow-x-auto">          
          <Table
          {...tableProps}
          childComponents={{
            cellText: {
              content: (props) => {
                // eslint-disable-next-line default-case
                switch (props.column.key){
                  case 'Actions': return <CustomCell {...props}/>;                
                }
              }
            }
          }}
          dispatch={dispatch1}
        />
      </div>
        </div>
      </div>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    },
  )(PackingPublishListTab),
);